<template>
    <div class="resourcesItem" @click="courseHour">
        <div class="head">
            <div class="h-left">
                <img :src="resourceData.icon | filterUrl" alt="" />
            </div>
            <div class="h-right">
                <h4>{{ resourceData.courseName }}</h4>
                <p>
          <span style="margin-right: 15px">
            <svg t="1637042125261" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3023" width="18" height="18">
              <path
                  fill="#999"
                  d="M110.933333 352l384 192c4.266667 2.133333 10.666667 4.266667 17.066667 4.266667s10.666667-2.133333 17.066667-4.266667l384-192c12.8-6.4 19.2-19.2 19.2-32s-8.533333-25.6-19.2-32l-384-192c-10.666667-4.266667-21.333333-4.266667-32 0l-384 192c-12.8 6.4-19.2 19.2-19.2 32s6.4 25.6 17.066666 32zM512 168.533333L814.933333 320 512 471.466667 209.066667 320 512 168.533333zM878.933333 672L512 855.466667 145.066667 672c-17.066667-8.533333-38.4-2.133333-49.066667 17.066667-8.533333 17.066667-2.133333 38.4 17.066667 49.066666l384 192c4.266667 2.133333 10.666667 4.266667 17.066666 4.266667s10.666667-2.133333 17.066667-4.266667l384-192c17.066667-8.533333 25.6-29.866667 17.066667-49.066666-12.8-19.2-34.133333-25.6-53.333334-17.066667z"
                  p-id="3024"
              ></path>
              <path
                  fill="#999"
                  d="M878.933333 480L512 663.466667 145.066667 480c-17.066667-8.533333-38.4-2.133333-49.066667 17.066667-8.533333 17.066667-2.133333 38.4 17.066667 49.066666l384 192c4.266667 2.133333 10.666667 4.266667 17.066666 4.266667s10.666667-2.133333 17.066667-4.266667l384-192c17.066667-8.533333 25.6-29.866667 17.066667-49.066666-12.8-19.2-34.133333-25.6-53.333334-17.066667z"
                  p-id="3025"
              ></path>
            </svg>
            {{ resourceData.childCourseCount }}节
          </span>
                    <span>
            <svg t="1637041983071" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1229" width="18" height="18">
              <path
                  fill="#999"
                  d="M512 64c-256 0-460.8 208-460.8 460.8s208 460.8 460.8 460.8 460.8-208 460.8-460.8S768 64 512 64zM512 940.8c-227.2 0-412.8-185.6-412.8-412.8s185.6-412.8 412.8-412.8 412.8 185.6 412.8 412.8S742.4 940.8 512 940.8z"
                  p-id="1230"
              ></path>
              <path
                  fill="#999"
                  d="M809.6 544l-278.4 0 0-281.6c0-12.8-9.6-22.4-22.4-22.4-12.8 0-22.4 9.6-22.4 22.4l0 307.2c0 12.8 9.6 22.4 22.4 22.4 0 0 3.2 0 3.2 0l297.6 0c12.8 0 22.4-9.6 22.4-22.4C832 553.6 822.4 544 809.6 544z"
                  p-id="1231"
              ></path>
            </svg>
            {{ resourceData.period }}
          </span>
                </p>
                <template>
                    <p>已使用：{{ resourceData.configUserCount || 0 }} 人次</p>
                    <p v-if="!resourceData.isLimitUser">剩余可用：无限制</p>
                    <p v-else>剩余可用：{{ resourceData.maxUserCount - resourceData.configUserCount }} 人次</p>
                </template>
            </div>
        </div>
        <div class="describe" :title="resourceData.description">
            <template v-if="!$scopedSlots.footer">{{ resourceData.description }}</template>
            <div v-if="$scopedSlots.footer" class="resour-footer">
                <slot name="footer"></slot>
            </div>
        </div>
        <a-modal width="700px" :title="detailsModal.title" v-model="detailsModal.visible" destroyOnClose :footer="null">
            <div id="introduceContent"></div>
        </a-modal>
    </div>
</template>

<script>
import E from 'wangeditor'

export default {
    name: 'ResourcesItem',
    props: {
        resourceData: Object,
        lookCourseHour: undefined,
    },
    data() {
        return {
            detailsModal: {
                title: '详情',
                visible: false,
            },
        }
    },
    mounted() {
        console.log(this.resourceData)
    },
    methods: {
        number(n) {
            const data = [
                { value: 1, name: '认知能力' },
                { value: 2, name: '心理品质' },
                { value: 4, name: '生涯规划' },
            ]
            switch (n) {
                case 7:
                    return ['认知能力', '心理品质', '生涯规划']
                case 6:
                    return ['心理品质', '生涯规划']
                case 5:
                    return ['认知能力', '生涯规划']
                case 3:
                    return ['认知能力', '心理品质']
                default:
                    return data.filter((f) => f.value === n).map((m) => m.name)
            }
        },
        lookDetails() {
            this.detailsModal.visible = true
            setTimeout(() => {
                const editor = new E('#introduceContent')
                editor.create()
                editor.config.height = 200
                editor.txt.html(this.resourceData.introduce)
                editor.disable()
            }, 100)
        },
        courseHour() {
            if (typeof this.lookCourseHour !== 'undefined') {
                this.$router.push(`/assess/resources/courseHour?courseId=${this.resourceData.courseId}`)
            }
        },
    },
}
</script>

<style scoped>
.resourcesItem {
    width: 440px;
    height: 260px;
    border-radius: 3px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    margin-right: 20px;
    margin-bottom: 20px;
    float: left;
    position: relative;
    line-height: 1;
    border: 1px solid #fff;
}
.resour-footer {
    position: absolute;
    right: 10px;
    bottom: 8px;
    display: none;
}
.resourcesItem:hover .resour-footer {
    display: block;
}

p,
span,
img {
    margin: 0;
    padding: 0;
}

.head {
    display: flex;
    height: 150px;
}

.h-left {
    flex-shrink: 0;
}

.h-right {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px 15px 0;
}

img {
    width: 186px;
    height: 242px;
    object-fit: cover;
}

.h-title {
    color: #fff;
    background-color: #4191f7;
    border-radius: 2px;
    padding: 3px 5px;
    font-size: 12px;
    position: absolute;
    left: 5px;
    top: 5px;
    opacity: 0.9;
}

.grey {
    font-size: 13px;
    background-color: #f7f7f7;
    border-radius: 5px;
    padding: 3px 6px;
    color: #575757;
    border: 1px solid #ebebeb;
    margin-right: 8px;
}

.blue {
    color: #4191f7;
    background-color: #e9f7fe;
    border: 1px solid #9fd4fb;
    border-radius: 5px;
    padding: 2px 5px;
    font-size: 12px;
    margin-right: 8px;
}

.h-right h4 {
    color: #000;
    font-size: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.h-right svg {
    vertical-align: text-top;
}

.describe {
    height: 70px;
    padding: 5px;
    line-height: 23px;
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    margin-top: 5px;
    width: 50%;
    position: absolute;
    right: 22px;
    bottom: 16px;
}

#introduceContent >>> .w-e-toolbar {
    display: none;
}

#introduceContent >>> .w-e-text-container {
    border: none !important;
}
</style>
